import React, { ReactNode, Fragment, useState, useEffect } from "react";

import { IonIcon } from "@ionic/react";

import { sadOutline, thumbsUpOutline } from "ionicons/icons";

import "./style.css";

interface AlertProps {
  error?: string;
  title?: string;
  content?: string | ReactNode;
  variant?: string | "error" | "info";
  className?: string;
}

const Alert: React.FC<AlertProps> = ({
  error = "",
  title = "Alerta",
  content = "",
  variant = "error",
  className,
}) => (
  <div className={`alert-cmp ${className}`}>
    <div className={`alert ${error} ${variant}`}>
      <div className="title">{title}</div>
      <div className="content">{content}</div>
    </div>
  </div>
);

export const AlertSad: React.FC<{
  excerpt?: any;
}> = ({ excerpt }) => (
  <Alert
    title="Alerta"
    className="sad"
    variant="info"
    content={
      <Fragment>
        <div className="excerpt">{excerpt}</div>
        <div className="icon">
          <IonIcon size="large" icon={sadOutline} />
        </div>
      </Fragment>
    }
  />
);

export const AlertSuccess: React.FC<{
  excerpt?: any;
  action?: any;
}> = ({ excerpt, action }) => (
  <Alert
    title="Alerta"
    variant="success"
    content={
      <Fragment>
        <div className="excerpt">{excerpt}</div>
        <div className="icon">
          <IonIcon size="large" icon={thumbsUpOutline} />
        </div>
        <div className="action">{action}</div>
      </Fragment>
    }
  />
);

export const AlertInfoUpdateFail: React.FC<{
  onWillDimiss?: () => void;
  show: boolean;
  time?: number;
}> = ({ onWillDimiss, show = false, time = 5000 }) => {
  const [showLocal, setState] = useState(true);
  useEffect(() => {
    setState(show);
    if (showLocal && time !== 0) {
      const timeout = setTimeout(() => {
        if (onWillDimiss) onWillDimiss();
        setState(false);
        clearTimeout(timeout);
      }, time);
    }
  }, [show]);

  if (!show) return null;

  if (!showLocal) return null;

  return (
    <AlertSad
      excerpt={
        <div>
          <p>
            Infelizmente não podemos atualizar seus dados.
            <br /> Peço que tente novamente mais tarde!
          </p>
        </div>
      }
    />
  );
};

export const AlertRequestFail: React.FC<{}> = () => {
  return (
    <AlertSad
      excerpt={
        <div>
          <p>
            Infelizmente não tivemos como conectar ao servidor.
            <br /> Peço que tente novamente mais tarde!
          </p>
        </div>
      }
    />
  );
};

export default Alert;
